export default class JsonParsingError extends Error {
	json: string;

	constructor(message: string, json: string) {
		super(message);
		this.json = json;
	}
}
